import { render, staticRenderFns } from "./DomainDns.vue?vue&type=template&id=1341f024&"
import script from "./DomainDns.vue?vue&type=script&lang=js&"
export * from "./DomainDns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports